import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleContactClick = () => {
    // Close mobile menu first
    closeMobileMenu();
    // Scroll to top with a small delay to ensure menu is closed
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  const handleNavClick = () => {
    // Close mobile menu first
    closeMobileMenu();
    // Scroll to top with a small delay to ensure menu is closed
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  const handleLogoClick = () => {
    // Scroll to top first, then navigate
    window.scrollTo({ top: 0, behavior: 'smooth' });
    closeMobileMenu();
  };

  const handleDesktopNavClick = () => {
    // Scroll to top for desktop navigation
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 bg-slate-900 text-white shadow-lg z-50 border-b border-slate-800">
        <div className="container mx-auto px-4">
          <div className="flex justify-center items-center h-16 relative">

            {/* Logo */}
            <Link
              to="/"
              className="text-2xl max-[330px]:text-2xl min-[331px]:text-3xl lg:text-4xl font-extrabold tracking-tight text-white hover:opacity-90 transition"
              onClick={handleLogoClick}
            >
              MR<span className="text-sky-400">automotores</span>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden md:flex space-x-8 absolute right-0 text-sm font-medium text-slate-300">
              <Link to="/" className="hover:text-sky-400 transition-colors" onClick={handleDesktopNavClick}>Inicio</Link>
              <Link to="/catalogo" className="hover:text-sky-400 transition-colors" onClick={handleDesktopNavClick}>Catálogo</Link>
              <Link to="/contact" className="hover:text-sky-400 transition-colors" onClick={handleDesktopNavClick}>Contacto</Link>
            </nav>

            {/* Mobile Menu Button */}
            <div className="md:hidden absolute right-0">
              <button 
                className="text-slate-300 hover:text-white transition-colors p-2"
                onClick={toggleMobileMenu}
                aria-label="Toggle mobile menu"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {isMobileMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>

          </div>
        </div>
      </header>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          {/* Backdrop */}
          <div 
            className="fixed inset-0 bg-black/50 backdrop-blur-sm"
            onClick={closeMobileMenu}
          />
          
          {/* Menu Panel */}
          <div className="fixed top-16 left-0 right-0 bg-slate-900 border-b border-slate-800 shadow-xl">
            <nav className="container mx-auto px-4 py-4">
              <div className="space-y-3">
                <Link
                  to="/"
                  className="block w-full text-left px-4 py-3 text-white hover:bg-slate-800 rounded-lg transition-colors font-medium"
                  onClick={handleNavClick}
                >
                  Inicio
                </Link>
                <Link
                  to="/catalogo"
                  className="block w-full text-left px-4 py-3 text-white hover:bg-slate-800 rounded-lg transition-colors font-medium"
                  onClick={handleNavClick}
                >
                  Catálogo
                </Link>
                <Link
                  to="/contact"
                  className="block w-full text-left px-4 py-3 text-white hover:bg-slate-800 rounded-lg transition-colors font-medium"
                  onClick={handleContactClick}
                >
                  Contacto
                </Link>
              </div>
            </nav>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;